var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5719 19.0764L18.7254 28.9229C17.4605 27.6581 16.6821 25.9262 16.6821 23.9997C16.6821 20.1467 19.7956 17.0332 23.6486 17.0332C25.5751 17.0332 27.307 17.8116 28.5719 19.0764Z",
    stroke: "#362B24",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9739 11.877C31.5685 9.30831 27.6766 7.90723 23.6485 7.90723C16.7793 7.90723 10.3772 11.9548 5.92094 18.9602C4.16958 21.704 4.16958 26.3159 5.92094 29.0597C7.45823 31.4726 9.2485 33.5548 11.1944 35.2283",
    stroke: "#362B24",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6821 38.6535C18.9005 39.5876 21.2551 40.0935 23.6486 40.0935C30.5178 40.0935 36.92 36.046 41.3762 29.0406C43.1275 26.2968 43.1275 21.6849 41.3762 18.9411C40.734 17.9292 40.0335 16.9757 39.3135 16.0806",
    stroke: "#362B24",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4788 25.3623C29.9728 28.1061 27.735 30.3439 24.9912 30.8499",
    stroke: "#362B24",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7252 28.9229L4.18896 43.4591",
    stroke: "#362B24",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1075 4.54053L28.5713 19.0767",
    stroke: "#362B24",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEclose);
export default __webpack_public_path__ + "static/media/eclose.32d634188d03082c9934fd2c0e011b8e.svg";
export { ForwardRef as ReactComponent };